const ACTIONS = {
	CALL_STARTED: 'CALL_STARTED',
	CALL_ENDED: 'CALL_ENDED',
	CALL_RECEIVED: 'CALL_RECEIVED',
	CALL_REPLIED: 'CALL_REPLIED',
	CALL_REJECTED: 'CALL_REJECTED'
};

export default ACTIONS;
